export const SITE_ORIGIN = "https://molxno.dev";
export const SITE_NAME = "molxno.dev";
export const PERSON_NAME = "Santiago Molano Holguín";
export const PERSON_IMAGE = `${SITE_ORIGIN}/preview.png`;
export const PERSON_ID = `${SITE_ORIGIN}/#person`;
export const WEBSITE_ID = `${SITE_ORIGIN}/#website`;

export const SOCIAL_PROFILES = [
  "https://x.com/molxno",
  "https://www.linkedin.com/in/molanosantiago/",
  "https://github.com/molxno",
] as const;

export const CURRENT_EMPLOYER = {
  name: "Alternova Inc",
  url: "https://www.linkedin.com/company/alternova-inc/",
} as const;
